import React, { PropTypes } from 'react'
import { connect } from 'react-redux'

import Loading from 'components/Loading'

import FormContainer from './form-container'

const ShowDefault  = ({ __state, params}) => {
  if (Number(params.studentID) !== __state.get('student_id')) {
    return <Loading />
  }

  return (
    <FormContainer
      data={__state}
      studentID={params.studentID}
      isShow
    />
  )
}

ShowDefault.propTypes = {
  __state: PropTypes.object,
  params: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __state: state.advisingState,
  }
}

export default connect(mapStateToProps)(ShowDefault)



// WEBPACK FOOTER //
// ./src/containers/Advising/show-default.js